import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  ButtonStyled,
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
} from "./styles";

let query = `
  secondCardSection{
      overview
      title
      subtitle
      coverImage {
        data {
          attributes {
            url
          }
        }
      }
  }
`;

export default function HXInfo(props) {
  const { onScrollToPackage } = props;
  const [solutions, setSolutions] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { secondCardSection } = response || {};
    setSolutions(secondCardSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Book A Free Consultation";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    onScrollToPackage();
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <CardContainer>
        <CardText
          type={"title"}
          dangerouslySetInnerHTML={{ __html: solutions?.overview }}
        ></CardText>

        <CardListContainer>
          <CardImage src={solutions?.coverImage?.data?.attributes?.url} />

          <CardTextContainer>
            <CardText
              type={"title"}
              dangerouslySetInnerHTML={{ __html: solutions?.title }}
            ></CardText>
            <CardText
              type={"desc"}
              dangerouslySetInnerHTML={{ __html: solutions?.subtitle }}
            ></CardText>

            <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
          </CardTextContainer>
        </CardListContainer>
      </CardContainer>
    </GridContainerStyled>
  );
}
